import React, { useEffect } from 'react';
import { PortfolioCategorySubNav } from '../components/PortfolioCategorySubNav';
import { PortfoliosHero } from '../components/PortfoliosHero';
import LeadForm from '../components/LeadForm';

export const Portfolios = ({ category = 'materials' }) => {

  useEffect(()=> {
    const gaGroup = (window.localStorage.i18nextLng === 'ja') ? 'ja' : 'en';
    
    // Get active language, fire manual page view.
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: 'Toyota IP Solutions - Portfolios Page',
        page_location: window.location.href,
        page_path: window.location.pathname,
        send_to: gaGroup
    })
    }
  }, [category])

  return (
    <div id="portfolios">
      <PortfoliosHero />
      <PortfolioCategorySubNav category={category} />
      <LeadForm />
    </div>
  )
}